// Head.js
import React from "react";
import {HelmetProvider, Helmet} from "react-helmet-async";

const Head = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <link rel="shortcut icon" href="assets/images/favicon.ico" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;700&family=Roboto:wght@400;500;700&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="./assets/vendor/font-awesome/css/all.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="./assets/vendor/bootstrap-icons/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="./assets/vendor/tiny-slider/tiny-slider.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="./assets/vendor/glightbox/css/glightbox.css"
        />
        <link
          id="style-switch"
          rel="stylesheet"
          type="text/css"
          href="assets/css/style.css"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.css"
        />
      </Helmet>
    </HelmetProvider>
  );
};

export default Head;
